import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';
import { b as bem, h as hasNamedSlot } from './index.esm-7182addc.js';

const gravityWidgetCss = ".gravity-widget{box-shadow:0px 8px 12px 0px rgba(0, 15, 30, 0.0392156863), 0px 2px 4px 0px rgba(0, 15, 30, 0.0196078431)}.gravity-widget__header{align-items:center;background-color:#FFFFFF;border-radius:6px 6px 0 0;box-sizing:border-box;display:flex;gap:16px;height:56px;justify-content:space-between;overflow:hidden;padding:16px}.gravity-widget__header__content{display:flex;gap:16px}.gravity-widget__header__content ::slotted(*){margin-left:16px}.gravity-widget__header__heading__wrapper{flex:1 1 0%;text-align:start}.gravity-widget__header__heading__wrapper,.gravity-widget__header__collapsible-icon{align-items:center;background:none;border:0;justify-content:center;overflow:hidden;padding:0;text-overflow:ellipsis;white-space:nowrap}.gravity-widget__header__heading__wrapper--collapsible,.gravity-widget__header__collapsible-icon--collapsible{cursor:pointer}.gravity-widget__drag-handle{margin-left:16px}.gravity-widget__body{background-color:#FFFFFF;border-radius:0 0 6px 6px;border-top:1px solid rgba(0, 15, 30, 0.1);height:auto;opacity:1;transition:padding 0.125s cubic-bezier(0.32, 0, 0.32, 1), opacity 0.1s 0.125s linear}.gravity-widget__body--has-padding{padding:16px}.gravity-widget__body--collapsed{border:0;height:0;opacity:0;overflow:hidden;padding:0}";
const GravityWidgetStyle0 = gravityWidgetCss;

const GravityWidget = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.widgetCollapsed = createEvent(this, "widgetCollapsed", 5);
        this.collapseWidget = () => {
            this.collapsed = !this.collapsed;
        };
        this.generateClassNames = bem('gravity-widget');
        this.handleBodySlotChange = () => {
            this.hasBodySlot = hasNamedSlot(this.el, 'body');
        };
        this.bodyPadding = true;
        this.collapsed = false;
        this.collapsible = false;
        this.dragHandle = true;
        this.heading = '';
        this.hasBodySlot = false;
    }
    watchHandlerCollapsed() {
        this.widgetCollapsed.emit(this.collapsed);
    }
    renderDragHandle() {
        if (!this.dragHandle || !this.collapsed) {
            return;
        }
        return (h("span", { class: this.generateClassNames('drag-handle') }, h("gravity-icon", { name: "drag-handle", size: "small", color: "dark-subtle" })));
    }
    renderHeader() {
        const HeaderTag = this.collapsible ? 'button' : 'div';
        return (h("div", { class: this.generateClassNames('header') }, h(HeaderTag, { class: this.generateClassNames('header__heading__wrapper', {
                collapsible: this.collapsible,
            }), onClick: this.collapsible ? () => this.collapseWidget() : undefined }, h("gravity-heading", { class: this.generateClassNames('header__heading'), size: "small", weight: "medium", color: "dark" }, this.heading)), h("div", { class: this.generateClassNames('header__content') }, h("slot", { name: "menu" }), this.renderDragHandle(), this.collapsible && (h("button", { class: this.generateClassNames('header__collapsible-icon', {
                collapsible: this.collapsible,
            }), onClick: this.collapsible ? () => this.collapseWidget() : undefined }, h("gravity-icon", { size: "xx-small", name: this.collapsed ? 'arrow-down-outline' : 'arrow-up-outline', color: "dark" }))))));
    }
    renderWidgetBody() {
        return (h("div", { class: this.generateClassNames('body', {
                'collapsed': this.collapsed || !this.hasBodySlot,
                'has-padding': this.bodyPadding,
            }) }, h("slot", { name: "body", onSlotchange: this.handleBodySlotChange })));
    }
    componentWillLoad() {
        // Necessary for pre-rendered content as the 'slotchange' event is not fired on initial render
        this.hasBodySlot = hasNamedSlot(this.el, 'body');
    }
    render() {
        return (h("div", { key: 'c6ca8e4ff739dfca3e02e3320b4ba7e7695553b9', class: this.generateClassNames() }, this.renderHeader(), this.renderWidgetBody()));
    }
    get el() { return getElement(this); }
    static get watchers() { return {
        "collapsed": ["watchHandlerCollapsed"]
    }; }
};
GravityWidget.style = GravityWidgetStyle0;

export { GravityWidget as gravity_widget };

//# sourceMappingURL=gravity-widget.entry.js.map